// extracted by mini-css-extract-plugin
export var LogoShapeHidden = "index-module--LogoShapeHidden--716c5";
export var LogoShapeShow = "index-module--LogoShapeShow--66cc3";
export var LogoTextHidden = "index-module--LogoTextHidden--c3db1";
export var LogoTextShow = "index-module--LogoTextShow--58646";
export var logo = "index-module--logo--31ff1 w-[101px] mOnly_w-[150px] relative flex items-center h-10";
export var logoHidden = "index-module--logoHidden--ea693 w-[234px] hidden";
export var logoShape = "index-module--logoShape--34263 fill-white w-[52px] mOnly_w-[42px] mOnly_h-10 absolute w-auto";
export var logoText = "index-module--logoText--b9625 fill-white w-[101px] mOnly_w-[100px] mOnly_h-10 absolute";
export var navOpened = "index-module--navOpened--75b70 text-green lg_top-center";
export var root = "index-module--root--1fc55 me-auto primary-anime relative z-[11] top-0";